export const FirebaseConfig = {
	"apiKey": "AIzaSyBnzdnFYtRouPSawIamcCOosgiqInrVE18",
	"authDomain": "oxi-30-car-a0048.firebaseapp.com",
	"databaseURL": "https://oxi-30-car-a0048-default-rtdb.firebaseio.com",
	"projectId": "oxi-30-car-a0048",
	"storageBucket": "oxi-30-car-a0048.firebasestorage.app",
	"messagingSenderId": "704360537243",
	"appId": "1:704360537243:web:4d25fa652b3e1eac8fba3e"
}; 